<mat-label class="subHeading">Bank Name<span *ngIf="required" class="star">*</span></mat-label>
<mat-select [formControlName]="controlName" placeholder="Select Bank Name" [multiple]="multiple">
    <ng-container *ngFor="let bankName of bankNames">
        <mat-option [value]="bankName">{{bankName}}</mat-option>
    </ng-container>
</mat-select>